import { useFlash } from "@/hooks/use-flash";
import { useTheme } from "@/hooks/use-theme";
import { PropsWithOptionalUser } from "@/types";
import { Head, usePage } from "@inertiajs/react";
import { PropsWithChildren } from "react";
import { Toaster } from "sonner";

function AuthLayout({ children }: PropsWithChildren) {
  const { flash, page_title } = usePage()
    .props as unknown as PropsWithOptionalUser;
  useFlash(flash);
  const { theme } = useTheme();

  return (
    <>
      <Head title={page_title} />
      <Toaster theme={theme} />
      <main>{children}</main>
    </>
  );
}

export default AuthLayout;
